import React from 'react';
import { motion } from 'framer-motion';
const categories = [{
  title: 'Womenswear',
  image: 'https://cdn.magicpatterns.com/uploads/bMzdmqtiahnnmMbnKaQtb9/image.png',
  size: 'large'
}, {
  title: 'Menswear',
  image: 'https://cdn.magicpatterns.com/uploads/24GiQwrwzepMESJJTXz3Q3/image.png',
  size: 'small'
}, {
  title: 'Bespoke Design',
  image: 'https://cdn.magicpatterns.com/uploads/gLF2b8eF4zmaV83H3cDGAQ/image.png',
  size: 'small'
}];
export function CategoryGrid() {
  return <section className="py-32 px-6 bg-white" data-id="element-108">
      <div className="max-w-[1800px] mx-auto" data-id="element-109">
        <div className="text-center mb-20" data-id="element-110">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-6 block text-black/40" data-id="element-111">
            The Collections
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl md:text-5xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase" data-id="element-112">
            Explore Our Heritage
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-113">
          {categories.map((cat, idx) => <motion.div key={cat.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: idx * 0.2
        }} className="relative group cursor-pointer overflow-hidden aspect-[3/4] bg-grey-divider" data-id="element-114">
              <img src={cat.image} alt={cat.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" data-id="element-115" />
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/30 transition-colors duration-500" data-id="element-116" />

              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8" data-id="element-117">
                <h3 className="text-white text-xl sm:text-2xl md:text-4xl font-display font-bold tracking-[0.1em] md:tracking-[0.2em] uppercase drop-shadow-lg" data-id="element-118">
                  {cat.title}
                </h3>
                <div className="w-12 h-[1px] bg-white mt-6 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-119" />
                <span className="text-white text-xs font-display font-bold uppercase tracking-[0.3em] mt-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-120">
                  View Collection
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}